// extracted by mini-css-extract-plugin
export default {"zones":"index_zones__8I7SY","action":"index_action__bZ5lF","card":"index_card__hOJM1","content":"index_content__tM-UR"};